import {ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges, ViewChild} from '@angular/core';
import {StickyPopover} from 'asax-common';
import {SkyObject} from '../../aladin-sky-objects.service';

const simbadOjectUrl = 'https://simbad.u-strasbg.fr/simbad/sim-id?Ident=';
const nedObjectUrl = 'https://ned.ipac.caltech.edu/byname?objname=';

@Component({
  selector: 'asax-sky-view-aladin-popover-sky-object',
  templateUrl: './aladin-popover-sky-object.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AladinPopoverSkyObjectComponent implements OnChanges {
  @ViewChild('stickyPopover', {static: true}) stickyPopover: StickyPopover;

  @Input() skyObject: SkyObject;

  simbadOjectUrl = simbadOjectUrl;
  nedObjectUrl = nedObjectUrl;
  encodeURIComponent = encodeURIComponent;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.skyObject) {
      this.onSkyObject();
    }
  }

  close(): void {
    this.stickyPopover?.close();
  }

  closeWithTimeout(): void {
    this.stickyPopover?.closeWithTimeout();
  }

  private onSkyObject(): void {
    if (this.skyObject) {
      this.stickyPopover?.open();
    } else {
      this.stickyPopover?.close();
    }
  }
}
